const updates = [
  {
    date: '2026-07-30',
    tag: '新片上线',
    title: '《星际征途：新纪元》高清版正式上线',
    desc: '年度最受期待的科幻大片现已登陆六六影院，1080P超清画质带来沉浸式太空冒险体验。',
  },
  {
    date: '2026-07-28',
    tag: '片库更新',
    title: '喜剧片专区新增20部经典作品',
    desc: '涵盖周星驰、金·凯瑞等国内外喜剧大师的代表作，周末爆笑马拉松即刻开启。',
  },
  {
    date: '2026-07-26',
    tag: '功能优化',
    title: '智能推荐算法全面升级',
    desc: '根据你的观影偏好，更精准地推荐你可能喜欢的电影，发现更多隐藏好片。',
  },
  {
    date: '2026-07-24',
    tag: '新片上线',
    title: '《暗夜追踪》悬疑动作大片独家首播',
    desc: '紧张刺激的警匪对决，豆瓣高分悬疑力作，全网首播就在六六影院。',
  },
  {
    date: '2026-07-22',
    tag: '专题策划',
    title: '「夏日电影马拉松」主题活动上线',
    desc: '精选50部暑期必看影片，陪你度过炎炎夏日。参与话题互动还有惊喜福利。',
  },
  {
    date: '2026-07-20',
    tag: '片库更新',
    title: '经典港片专区扩容至500+部',
    desc: '从邵氏经典到银河映像，香港电影黄金时代的精华作品一站式收录。',
  },
  {
    date: '2026-07-18',
    tag: '功能优化',
    title: '播放器升级：支持倍速播放与记忆续播',
    desc: '新增0.75x至2x倍速播放功能，退出后自动记忆播放进度，观影体验更流畅。',
  },
  {
    date: '2026-07-16',
    tag: '新片上线',
    title: '《遇见你的夏天》浪漫喜剧温情上映',
    desc: '年度最甜爱情电影，治愈系画风搭配温暖故事，收获豆瓣8.9分好评。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            六六影院片库更新与功能优化一手掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-3 md:left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5 md:gap-8 pb-8 last:pb-0">
                <div className="relative z-10 flex-shrink-0 w-6 md:w-[38px] flex justify-center pt-1">
                  <div className={`w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 ${
                    idx < 3
                      ? 'border-primary-500 bg-primary-100'
                      : 'border-secondary-400 bg-background-50'
                  }`}></div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      item.tag === '新片上线'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '片库更新'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '功能优化'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}